import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

//AXIOS REQUEST
axios.interceptors.request.use(
  config => {
    // config.headers['Content-Type'] = 'application/json';
    // config.headers["Cache-Control"] = "no-cache";
    // config.headers["Pragma"] = "no-cache";

    const token = localStorage.getItem("token");
    if (token) config.headers["Authorization"] = "Bearer " + token;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);